import React, { Component } from "react";
import { Link } from "react-router-dom";

class bookGrid extends Component {

	constructor(props) {
		super(props);
		//this.state = { bl: [] };

		//alert(JSON.stringify(props));

		this.state = { totalcount: 0, booklist: [], loading: true };

		fetch(props.fetchurl)
			.then(response => response.json())
			.then(data => {
				//this.setState({ forecasts: data, loading: false });
				//alert(JSON.stringify(data));
				//alert(data.totalcount);
				//this.state.totalcount = data.totalcount;
				//this.state.loading = true;
				//alert(this.state.totalcount);

				this.setState({ totalcount: data.totalcount, booklist: data.lstresult, loading: false });
			});
	}

	dorender() {
		let bookDummy = this.state.booklist;

		return (
			bookDummy.map((book, index) => {
				//console.log("bookid: " + book.id);
				return (
					
					<React.Fragment>
						<li className="bookGrid-item">
							<div className="bookGrid-item-container">
								<Link to={`/book/${book.id}`}>
									<div className="thumbnail">
										<img className="thumbnail-image" src={`/api/AB/GetCoverImage?thumb=2&imgid=${book.id}`} alt={book.subject} />
									</div>
									<h3 className="bookGrid-title">{book.subject}</h3>
									<h4 className="bookGrid-author">{book.authorName}</h4>
								</Link>
							</div>
						</li>
					</React.Fragment>
				);
			})
		);
	}

	render() {

		let contents = this.state.loading === true
			? "Loading..."
			: this.dorender();

		return (
			<ul className="bookGrid">
				{contents}
			</ul>
		);
	}
}

export default bookGrid;
